// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.ClientFilterSpec
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { DataFieldTypeEnum } from "abweb/dto/generated/ds/DataFieldTypeEnum";
import { DataSourceFilterType } from "abweb/dto/generated/ds/DataSourceFilterType";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class ClientFilterSpecBase {
  /** Do NOT invoke directly, instead use strongly typed createClientFilterSpecBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadd.ClientFilterSpec";
  }
  initFromJson(json, deserializeContext) {
    this.initClientFilterSpec(json.displayValue != null ? json.displayValue : null, json.fieldDataType != null ? DataFieldTypeEnum.fromJson(json.fieldDataType) : null, json.fieldPath != null ? json.fieldPath : null, json.filterType != null ? DataSourceFilterType.fromJson(json.filterType) : null, TSOGUtils.decodeObject(json.filterValue, null, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "filterValue")));
  }
  initClientFilterSpec(displayValue, fieldDataType, fieldPath, filterType, filterValue) {
    this._displayValue = displayValue;
    this._fieldDataType = fieldDataType;
    this._fieldPath = fieldPath;
    this._filterType = filterType;
    this._filterValue = filterValue;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["displayValue"] = this._displayValue;
    if (this._fieldDataType != null) {
      retVal["fieldDataType"] = this._fieldDataType;
    }
    retVal["fieldPath"] = this._fieldPath;
    retVal["filterType"] = this._filterType;
    if (this._filterValue != null) {
      retVal["filterValue"] = TSOGUtils.toTSOGNativeObject(this._filterValue, serializeContext);
    }
    return retVal;
  }
  get displayValue() {
    return this._displayValue;
  }
  set displayValue(value) {
    this._displayValue = value;
  }
  get fieldDataType() {
    return this._fieldDataType;
  }
  set fieldDataType(value) {
    this._fieldDataType = value;
  }
  get fieldPath() {
    return this._fieldPath;
  }
  set fieldPath(value) {
    this._fieldPath = value;
  }
  get filterType() {
    return this._filterType;
  }
  set filterType(value) {
    this._filterType = value;
  }
  get filterValue() {
    return this._filterValue;
  }
  set filterValue(value) {
    this._filterValue = value;
  }
}
//# sourceMappingURL=ClientFilterSpecBase.js.map
